import { ReactComponent as Link } from '@pkg/assets/icons/v1/link.svg';
import { ReactComponent as TransferArrows } from '@pkg/assets/icons/v1/transfer-arrows.svg';
import { ReactComponent as TripleDotsIcon } from '@pkg/assets/icons/v1/triple-dots.svg';
import { ReactComponent as ETH } from '@pkg/assets/icons/v2/ethereum.svg';

export const Icons = {
    ETH,
    Link,
    TransferArrows,
    TripleDotsIcon,
};
